const initialState = {
  logo_file: '',
  home_url: ''
};

export const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VIEWER_SETTINGS":
      return {
        ...state,
        logo_file: action.viewer_settings.data.data.logo_file,
        home_url: action.viewer_settings.data.data.home_url,
      };
    default:
      return state;
  }
};
